module.exports = __webpack_public_path__ + "img/icon_top_banner3.49e31d93.png";